import { useRenders } from 'global/cnr/contexts/useHelpers/useRenders';
import { useContext, useEffect, useMemo, useRef, useState } from 'react';
import FrameworkProvider from '../cnr/contexts/FrameworkContent';
import { ParentContext } from "../cnr/contexts/ParentContext";
import { gEnums } from "../enums/globalEnums";
import { _animateTypes } from '../motions/AnimateComponent';
import MotionComponent from '../motions/MotionComponent';
import CreateFeedEvent from '../viewSettings/events/CreateFeedEvent';
import PageFramework from "./PageFramework";
import { useLocation } from 'react-router-dom';

const _forceTransition = false

/**
 * 
 * @returns PageFramework within a FrameworkProvider
 */
const PageDevice = () => {

  const location = useLocation()
  const previousPathRef = useRef(location.pathname)

  const isNewRoute = previousPathRef.current !== location.pathname

  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {};

  const { app_state, paps_state, transition_state } = states ?? {};
  const { transitions } = transition_state ?? {};
  const transition = transitions ? transitions[_animateTypes.route] : null;
  const { showTransition } = transition ?? {};
  const { view } = paps_state ?? {};

  useRenders('PageDevice', true, true)

  const [pageGeneration, setPageGeneration] = useState(0);

  useEffect(() => {
    setPageGeneration(prev => prev + 1);
    previousPathRef.current = location.pathname
    console.log('🟢🔄 ROUTE CHANGED:', location.pathname)
  }, [location.pathname])

  const isMobileDevice = _.get(app_state, 'currentEnvironment.platform.isMobileDevice', false);

  const content = view === 'createFeedEvent'
    ? <CreateFeedEvent />
    : (
      <FrameworkProvider
        addSettings={false}
        pageGeneration={pageGeneration}
        mediaDeviceType={
          isMobileDevice
            ? gEnums.mediaDeviceTypes.mobile
            : gEnums.mediaDeviceTypes.desktop
        }
        hasSettings={true}
        isMobileDevice={isMobileDevice}
      >
        <PageFramework />
      </FrameworkProvider>
    );

  return showTransition || _forceTransition
    ? (
      <MotionComponent
        transition={transition}
        isNewRoute={isNewRoute}
      >
        {content}
      </MotionComponent>
    )
    : content;
};

export default PageDevice